import { NgModule } from '@angular/core';
import { SearchEvents, SearchResultEvents, ResortDetailsPageEvents, CheckoutPageEvents}  from './resort-custom-events';
import { ResortInsightsService } from './resort-insights.service';

@NgModule({
    imports:[ ],
    declarations: [  ],
    exports: []
})
class ResortInstrumentationModule{}

export {ResortInstrumentationModule, SearchEvents, SearchResultEvents, ResortDetailsPageEvents, CheckoutPageEvents , ResortInsightsService};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/instrumentation/resort-instrumentation.module.ts